// App-wide configuration for Azure and Firebase Storage
// Place your SAS URL here. Example:
// export const BLOB_SAS_URL = "https://<account>.blob.core.windows.net/<container>/<filename>?<sas-token>";

// AZURE CONFIGURATION (keeping for reference/fallback)
export const APPS_BLOB_BASE_URL = "https://appesteemstorage.blob.core.windows.net/aebuild";
// set SAS token - needs list and read access to containers and objects
// This will be dynamically loaded from Firebase during authentication
let APPS_BLOB_SAS_TOKEN = ""
export const APPS_BLOB_INSPECT_ROOT = "Inspect";

// NOT NEEDED FOR NOW...
export const BLOB_SAS_URL = ""
export const BLOB_CONTAINER_NAME = "testvideos";

// Method to update the SAS token
export const updateSasToken = (newToken) => {
  APPS_BLOB_SAS_TOKEN = newToken;
  // console.log('SAS Token updated:', newToken);
};

// Method to get the current SAS token
export const getSasToken = () => {
  return APPS_BLOB_SAS_TOKEN;
};

// FIREBASE STORAGE CONFIGURATION
export const FIREBASE_STORAGE_INSPECT_ROOT = "Inspect";

// InspectorClick API (autoinspect request)
export const INSPECTORCLICK_API_BASE_URL = "https://api.inspectorclick.com/3c/inspectorClick";
//export const INSPECTORCLICK_API_BASE_URL = "http://localhost:5001/3c/inspectorClick";

// Run files loaded from Firebase Storage for each inspection run
export const RUN_FILES_TO_LOAD = [
  'visualStory.json',
  'summary_effects.json',
  'metadata.json',
  'recording.mp4',
  'watch_log.jsonl',
  'fileinfo.json',
  'copycert.json',
  'bitsinfo.json',
  'collect.json',
  'autoinspect.json',
  'installerfileinfo.json',
  // macOS collector diagnostics (absent on Windows runs; loaders treat a missing file as null)
  'mac_events.jsonl',
  'maccollect.log',
];

export const RUN_FILE_KEY_MAP = {
  'visualStory.json': 'visualStory',
  'summary_effects.json': 'summaryEffects',
  'metadata.json': 'metadata',
  'recording.mp4': 'video',
  'watch_log.jsonl': 'watchlog',
  'fileinfo.json': 'fileinfo',
  'copycert.json': 'copycert',
  'bitsinfo.json': 'bitsinfo',
  'collect.json': 'storyitems',
  'autoinspect.json': 'autoinspect',
  'installerfileinfo.json': 'installerfileinfo',
  'mac_events.jsonl': 'macEvents',
  'maccollect.log': 'macCollectLog',
};
